export default "__VITE_ASSET__14d9f8e1__"